import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FilterHeader } from '@estimation/features/FilterHeader/';
import { NewSolution } from '@estimation/features/NewSolution/';
import styles from './styles.module.scss';
export function PreProcessFilterHeader() {
    return (_jsxs("div", { className: styles.container, children: [_jsx(FilterHeader, {}), _jsx(NewSolution, {})] }));
}
